import { render, staticRenderFns } from "./monitoring.coreos.com.alertmanagerconfig.vue?vue&type=template&id=2aea0833&scoped=true&"
import script from "./monitoring.coreos.com.alertmanagerconfig.vue?vue&type=script&lang=js&"
export * from "./monitoring.coreos.com.alertmanagerconfig.vue?vue&type=script&lang=js&"
import style0 from "./monitoring.coreos.com.alertmanagerconfig.vue?vue&type=style&index=0&id=2aea0833&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea0833",
  null
  
)

export default component.exports